import { AIRSHOPPING_FLIGHT_CARD_OWNERCODE_KEY } from "./constants";
import { getSessionStorage } from "./utils";

export const CMS_ITEMS = {
  CATALOGUE_SOURCE: "catalogue_source",
  SERVICE_CATEGORY: "service_category",
  SERVICE: "service",
  AIRLINE: "airlines",
  PAGE_CARD_USAGE_DATA: "page_card_usage_data",
  ORDER_DATA_TEMPLATES: "order_data_template",
  AGENCY_DATA_TEMPLATES: "agency_data_export_templates",
  AGENCY_EXT_DATA_TEMPLATES: "agency_data_export_templates",
  STATIONS: "stations",
  TICKET_TRANSACTION_KEYS: "ticket_transaction_data_keys",
};

// const flightOwnerCode = getSessionStorage(
//   AIRSHOPPING_FLIGHT_CARD_OWNERCODE_KEY
// );

export const CMS_PARAMS = {
  catalogue_source: {
    fields: "name,taxonomy_code",
    deep: "*",
  },
  service_category: {
    fields: "icon,name,taxonomy_code",
    deep: "*",
  },
  service: {
    fields: `name,taxonomy_code,description,icon,image,airline_content.order_quantity_uom.code, airline_content.image, airline_content.airlines_short_code`,
    // deep: `{ "airline_content": { "_filter": { "airlines_short_code": { "_eq": null}}}`,
    limit: `-1`,
  },
  airline: {
    fields: "name, icon.*, icon_tail.*, display_name, short_code",
    limit: `-1`,
    "filter[status][_eq]": "published",
  },
  page_card_usage_data: {
    fields: "status,card_brand.logo,agency_short_code,card_brand.brand_code,",
    deep: "*",
  },
  agency_data_export_templates: {
    fields: "status,organization_short_code",
    deep: "*",
  },
  agency_data_export_templates_block_data_export_with_ext_mapping: {
    fields:
      "id,status,organization_short_code,fields.block_data_export_with_ext_mapping_id.id,fields.block_data_export_with_ext_mapping_id.name,fields.block_data_export_with_ext_mapping_id.value,fields.block_data_export_with_ext_mapping_id.name,fields.block_data_export_with_ext_mapping_id.field_name,fields.*",
    deep: "*",
  },
  page_card_usage_data_fields_item: {
    fields:
      "fields.item.id,fields.item.name,fields.item.description,fields.item.required,fields.item.maps_to",
    deep: "*",
  },
  order_data_template: {
    fields:
      "id,status,organisation_short_code,template_name,template_description,template_type",
    deep: "*",
  },
  order_data_template_fields: {
    fields:
      "collectionfields.item.id,fields.item.id,fields.item.name,fields.item.description,fields.item.required,fields.item.maps_to,fields.item.field_context,fields.*",
    deep: "*",
  },
  order_template_block_data_fields_item: {
    fields:
      "fields.block_data_field_with_ext_mapping_id.id,fields.block_data_field_with_ext_mapping_id.required, fields.block_data_field_with_ext_mapping_id.name,fields.block_data_field_with_ext_mapping_id.description, fieds.block_data_field_with_ext_mapping_id.required, fields.block_data_field_with_ext_mapping_id.maps_to,fields.block_data_field_with_ext_mapping_id.field_context",
    deep: "*",
  },
  stations: {
    fields:
      "type,station_name_en,location_code,sub_type,city_name_en,iso_country",
    deep: "*",
  },
};

export const CDN_DOMAIN = "https://cdn.llc.nuflights.com";
